import React, { ReactNode, FunctionComponent } from 'react';
import { FuriganaFormattedText } from '../../common/FormattedText';
import WithFontsForLanguage from '../../layout/WithFontsForLanguage';
import { List } from 'immutable';
import { useI18n } from 'app/components/localization';
import { Language } from 'app/constants/enums/Language';

interface ICoreProps {
  language?: Language;
  translation: string;
}

interface IListProps {
  language?: Language;
  translations: List<string>;
}

export interface ITranslationProps extends ICoreProps {
  children?: (props: ICoreProps) => ReactNode;
}

interface ITranslationListProps extends IListProps {
  children?: (props: IListProps) => ReactNode;
}

const Translation: FunctionComponent<ITranslationProps> = ({ children, translation, language }) =>
  <WithFontsForLanguage languageCode={language && language.id}>
    {children ? (children({ translation, language })) : (
      <FuriganaFormattedText text={translation} />
      )
    }
  </WithFontsForLanguage>;

export const TranslationList: FunctionComponent<ITranslationListProps> = ({
  children,
  translations,
  language,
}) => {
  const { t } = useI18n();
  return (
    <WithFontsForLanguage languageCode={language && language.id}>
      {children ? (children({ translations, language })) : (
        <Translation
          translation={translations.join(t('list-separator', undefined, { locale: language && language.id }))}
          language={language}
        />
      )}
    </WithFontsForLanguage>
  );
};

export default Translation;
